import { CustomDatePicker } from 'components/Datepicker'
import { inputRequiredStyle } from 'components/Datepicker/styles'
import { InputLabel } from 'components/InputLabel'
import { Label } from 'components/InputLabel/styles'
import { InputSelect } from 'components/InputSelect'
import { Toggle } from 'components/Toggle'
import { variablesListPacientDocumentType, variablesListPacientGender } from 'pages/NotificationTreatment/NotificationsTreatmentsSteps/NotificationData/helper'
import { BlueText } from 'pages/NotificationTreatment/NotificationsTreatmentsSteps/NotificationData/styles'
import React, { useState } from 'react'
import {
    Control,
    FieldErrors,
    FieldValues,
    UseFormRegister
} from 'react-hook-form'
import { IVariableReducer } from 'types/variable'

interface IFormPatientData {
    errors: FieldErrors<FieldValues>
    control: Control<FieldValues, any>
    register: UseFormRegister<FieldValues>
    incidentDate: Date
    involvePatient: boolean
    involvePatientMoreThenOne: boolean
    variableSelector: IVariableReducer
}

export default function FormPatientData({
    errors,
    control,
    register,
    incidentDate,
    involvePatient,
    involvePatientMoreThenOne,
    variableSelector
}: IFormPatientData) {
    const [patientInitials, setPatientInitials] = useState<string>()

    if (!involvePatient) {
        return null
    } else if (involvePatient && involvePatientMoreThenOne) {
        return null
    }
    

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const result = event.target.value.replace(/[^a-z]/gi, '')
        setPatientInitials(result.toLocaleUpperCase()?.split('').join('.'))
    }

    return (
        <div className="mt-6">
            <BlueText>Dados do paciente</BlueText>

            <div className="sm:grid-cols-12  grid-cols-1 grid gap-3 gap-y-3">
                <div className="sm:col-span-3">
                    <InputLabel
                        label="Iniciais do nome do paciente"
                        name="patient_initials"
                        value={patientInitials}
                        register={register}
                        maxLength={30}
                        placeholder="Digite aqui"
                        error={{
                            message: errors.patient_initials
                                ? 'Preenchimento obrigatório.'
                                : ''
                        }}
                        onChange={handleChange}
                    />
                </div>
            
                <div className="md:col-span-2 min-w-[173px]">
                    <CustomDatePicker
                        label="Data de nascimento"
                        name="patient_date_of_birth"
                        control={control}
                        required
                        placeholderData="Selecionar"
                        isError={Boolean(errors.patient_date_of_birth)}
                        error={Boolean(errors.patient_date_of_birth)}
                        maxDate={incidentDate}
                        customStyle='text-sm'
                    />
                </div>

                <div className="sm:col-span-2">
                    <InputSelect
                        placeholder="Selecionar"
                        errorStyle={`${errors.patient_gender
                                ? 'border border-errorText'
                                : ''
                            }`}
                        styleBoxOptions="mt-3.5"
                        searchPlaceHolder="Buscar"
                        label="Gênero do paciente"
                        name="patient_gender"
                        control={control}
                        data={variablesListPacientGender(variableSelector)}
                    />
                </div>

                <div className="sm:col-span-2">
                    <InputSelect
                        placeholder="Selecionar"
                        errorStyle={`${errors.document_type ? 'border border-errorText' : ''}`}
                        styleBoxOptions="mt-3.5"
                        searchPlaceHolder="Buscar"
                        label="Tipo de documento"
                        name="document_type"
                        control={control}
                        data={variablesListPacientDocumentType(variableSelector)}
                    />
                </div>

                <div className="sm:col-span-3">
                    <InputLabel
                        label="Número do documento"
                        name="document_number"
                        register={register}
                        maxLength={30}
                        placeholder="Digite aqui"
                        error={{
                            message: errors.document_number
                                ? 'Preenchimento obrigatório.'
                                : ''
                        }}
                    />
                </div>

            </div>
        </div>
    )
}
